.root {
  position: absolute;
  inset: 0;
}

/* The band under the lockup where content must not show at rest. Painted with the
   same atmosphere composition as ClientShell .atmosphere, offset by JS so its
   pixels coincide with the real atmosphere; JS clips it away as the lockup
   collapses. A static layer: only clip-path changes per frame. */
.cover {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  will-change: transform;
}

.coverPaint {
  position: absolute;
  left: 0;
  width: 100%;
  height: var(--app-viewport-stable-height, 100dvh);
  background:
    var(--page-overlay, none),
    var(--page-image, none),
    var(--bg-page);
}

.expanded {
  position: absolute;
  top: calc(var(--tg-safe-area-inset-top, env(safe-area-inset-top, 0px)) + 2px);
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 18px 12px;
  text-align: center;
}

/* Collapsed strip on the chrome row. Bottoms align (mockup): the logo box bottom
   sits on the name's text-box bottom, so the mark's ink rests on the text line. */
.strip {
  position: absolute;
  top: var(--tg-safe-area-inset-top, env(safe-area-inset-top, 0px));
  left: 0;
  right: 0;
  height: var(--lockup-strip-row);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 12px;
  visibility: hidden;
}

.logo {
  display: block;
  flex-shrink: 0;
  width: 50px;
  height: 44px;
  will-change: transform;
}

.logo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.name {
  margin: 0;
  flex-shrink: 0;
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 25px;
  line-height: 1.05;
  letter-spacing: 0.005em;
  color: var(--text-primary);
  white-space: nowrap;
  will-change: transform;
}

.expanded .name {
  margin-top: 6px;
}

/* Descriptor under the name (mockup .lh-tag). Fades during the collapse. */
.descriptor {
  margin-top: 4px;
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: var(--accent-deep);
  white-space: nowrap;
}
